import * as React from 'react'

import { EmbroideryFont } from '../../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { useRestrictedEmbroideryFonts } from '../../../../../../containers/EmbroideryContainer/utils/isEmbroideryColorAllowedForProduct'
import { FontSelector } from '../../../primitives/selectors/FontSelector/FontSelector'

export type TextFontPickerProps = {
  selectedFontKey: EmbroideryFont['key'] | undefined
  onSelectFont(font: EmbroideryFont): void
  errorMessage?: string
  disabled?: boolean
}

export const TextFontPicker: React.FC<TextFontPickerProps> = ({
  selectedFontKey,
  onSelectFont,
  errorMessage,
  disabled,
}) => {
  // Temporary unblocking of fonts for DTC. Remove this in LFE-188
  const fonts = useRestrictedEmbroideryFonts([])
  const labelId = React.useId()

  return (
    <FontSelector
      disabled={disabled}
      errorMessage={errorMessage}
      fonts={fonts}
      labelId={labelId}
      onSelectFont={onSelectFont}
      outlineWhenSelected
      selectedFontKey={selectedFontKey}
    />
  )
}
